import { RegisterOptions } from 'react-hook-form'
import { FormValues } from './index.context'
import { useTranslation } from 'react-i18next'

export const defaultValues: FormValues = {
  clientId: null,
  date: [],
}

export const useFormRules = (): Record<
  keyof FormValues,
  Omit<RegisterOptions<FormValues>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
> => {
  const { t } = useTranslation()
  return {
    clientId: {
      required: {
        value: true,
        message: t('IssuedCheckProcessingLog:validation.required.client'),
      },
    },
    date: {
      required: {
        value: true,
        message: t('IssuedCheckProcessingLog:validation.required.date'),
      },
    },
  }
}
